import { ChevronLeft } from '../../components/ui/icons';
import { cn } from '../../lib/cn';

export function BackBar({
  onBack,
  eyebrow,
  tone = 'dark'
}: {
  onBack: () => void;
  eyebrow: string;
  /** Dark for football fixture detail; light for cycling duel detail on the paper canvas. */
  tone?: 'dark' | 'light';
}) {
  const light = tone === 'light';

  return (
    <div className="relative flex items-center justify-between gap-3 pt-2 md:pt-5">
      <button
        type="button"
        onClick={onBack}
        className={cn('tap -ml-1 flex shrink-0 items-center gap-[2px]', light ? 'text-ink' : 'text-white')}
      >
        <ChevronLeft width={22} height={22} strokeWidth={2.4} />
        <span className="text-[16px] font-semibold tracking-snug">Back</span>
      </button>
      <div
        className={cn(
          'min-w-0 flex-1 truncate text-right text-[12px] font-bold uppercase tracking-[0.12em]',
          light ? 'text-ink3' : 'text-white/40'
        )}
      >
        {eyebrow}
      </div>
    </div>
  );
}
